<mat-card>
  <mat-card-content>
    <div class="mb-3">
      <h3>Ticket Strips in Current Draw</h3>
      <ag-grid-angular
        id="currentDrawNumbersGrid"
        class="ag-theme-quartz margin-top-med"
        data-testid="played-strips-table"
        [tooltipShowDelay]=0
        rowClass="table-row"
        domLayout='autoHeight'
        overlayNoRowsTemplate="<span>This user has no numbers in the current draw</span>"
        (gridReady)="onCurrentDrawGridReady($event)"
        [rowData]="playedStripRows"
        [columnDefs]="currentDrawColumnDefs">
      </ag-grid-angular>
    </div>

    @if (failedAutoplayStrips.length > 0) {
      <div class="mb-3">
        <h3>Failed Autoplay Strips</h3>
        <p class="text-muted">Click on a row to view failure details</p>
        <ag-grid-angular
          id="failedAutoplayGroupsGrid"
          class="ag-theme-quartz margin-top-med"
          data-testid="failed-autoplays-table"
          [tooltipShowDelay]=0
          rowClass="table-row clickable-row"
          domLayout='autoHeight'
          overlayNoRowsTemplate="<span>No failed autoplay strips</span>"
          (gridReady)="onFailedAutoplayGridReady($event)"
          (rowClicked)="onFailedAutoplayStripRowClick($event)"
          [rowData]="failedAutoplayStrips"
          [columnDefs]="failedAutoplayColumnDefs">
        </ag-grid-angular>
      </div>
    }

    <div class="mb-3">
      <h3>Autoplay Groups</h3>
      <ag-grid-angular
        id="autoplayGroupsGrid"
        class="ag-theme-quartz margin-top-med"
        data-testid="autoplay-groups-table"
        [tooltipShowDelay]=0
        rowClass="table-row"
        domLayout='autoHeight'
        overlayNoRowsTemplate="<span>This player has no autoplay groups</span>"
        (gridReady)="onAutoplayGroupsGridReady($event)"
        [rowData]="autoplayGroups"
        [columnDefs]="autoplayGroupsColumnDefs">
      </ag-grid-angular>
    </div>

  </mat-card-content>
</mat-card>
